module.exports = __webpack_public_path__ + "static/img/4777_phase_function_Paper_Points.dd53cee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4777_phase_function_Paper_Points.png
// module id = sihv
// module chunks = 0